import { render, staticRenderFns } from "./ViewMethodIntroduction.vue?vue&type=template&id=60d03cc1"
import script from "./ViewMethodIntroduction.vue?vue&type=script&lang=js"
export * from "./ViewMethodIntroduction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports